export default "__VITE_ASSET__PYm9$gVG__"